import React from "react";
import "../css/privacy.css";
import Footer from "./Footer";

function PrivacyPolicy() {
  return (
    <>
      <main>
        <div className="privacy-container">
          <h1>プライバシーポリシー</h1>

          <section>
            <h2>1. 個人情報の収集について</h2>
            <p>
              当サイトでは、ユーザーが適職診断をご利用いただく際に、氏名や住所等の情報を収集することがあります。
              これらの情報は、診断の個別対応および結果管理の目的でのみ使用されます。
            </p>
          </section>

          <section>
            <h2>2. 利用目的</h2>
            <p>
              収集した情報は以下の目的で利用します：
              <ul>
                <li>診断結果の個別表示および保存</li>
                <li>ユーザーごとの傾向分析</li>
                <li>不正利用の防止</li>
              </ul>
            </p>
          </section>

          <section>
            <h2>3. 第三者提供について</h2>
            <p>
              ご本人の同意がある場合、または法令に基づく場合を除き、
              収集した個人情報を第三者に提供することはありません。
            </p>
          </section>

          <section>
            <h2>4. 管理と安全対策</h2>
            <p>
              ユーザーの個人情報は、外部からの不正アクセス・漏洩・改ざん等を防止するため、
              適切なセキュリティ対策を講じて管理いたします。
            </p>
          </section>

          <section>
            <h2>5. Cookie・アクセスログ</h2>
            <p>
              利便性向上のためCookieを使用する場合がありますが、個人を特定する情報は含まれていません。
            </p>
          </section>

          <section>
            <h2>6. お問い合わせ</h2>
            <p>
              個人情報の取り扱いに関するお問い合わせは、運営者までご連絡ください。
              <br />
              例：<a href="mailto:info@myou-kou.com">info@myou-kou.com</a>
            </p>
          </section>

          <p className="date">【制定日】2025年3月27日</p>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
